import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
// import DatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css'
import { AiOutlineDollar, AiTwotoneDollarCircle } from 'react-icons/ai'
import { FaStar } from 'react-icons/fa6'
import { ImCross } from 'react-icons/im'
import { MdManageSearch, MdVerified, MdOutlinePayment } from 'react-icons/md'
import { RxUpdate } from 'react-icons/rx'
import { TbCloudDownload } from 'react-icons/tb'
import { Link } from 'react-router-dom'
import { cdnUrl, homeUrl } from '../../../utils/api'
import Pagination from '../../Pagination/Pagination'
import { PopUp } from '../../Resources'
import DatePicker from '../../Resources/DatePicker/DatePicker'
import TableV1 from '../../Resources/TableV1/TableV1'
import TitleContainer from '../../Resources/TitleContainer/TitleContainer'
import { StartDate, EndDate } from '../../Resources/dateFormatter'
import classes from './ActiveSellers.module.css'
import PopUpOne from './PopUpDropdown/PopUpOne '
import Popup from './Popup/Popup'
import SearchBar from './SearchBar'
import SubsPopup from './SubsPopup/SubsPopup'

export default function ActiveSellers(props) {
    const [activePopUp, setActivePopUp] = useState(null)
    const [commissionPopup, setCommissionPopup] = useState(false)
    const [subsPopup, setSubsPopup] = useState(false)
    const [singleSellerInfo, setSingleSellerInfo] = useState([])

    const planOptions = [
        { value: '', label: 'All Plans' },
        { value: 'basic', label: 'Basic' },
        { value: 'standard', label: 'Standard' },
        { value: 'premium', label: 'Premium' },
    ]

    // CSV export
    const userInfoExportData = props.allSellers.map((e) => ({
        name: e.User.name,
        email: e.User.email,
        phone: e.User.phone,
        company: e.Seller.page_name,
    }))

    // Handle dates
    const handleStartDateChange = (date) => {
        const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss")
        props.setStartDate(StartDate(formattedDate))
    }
    const handleEndDateChange = (date) => {
        const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss")
        props.setEndDate(EndDate(formattedDate))
    }
    const clearDate = () => {
        props.setStartDate('')
        props.setEndDate('')
    }

    const resetAll = () => {
        props.setSearch({ ...props.search, value: '', isSearchAble: false })
    }
    const removeSpace = (str) => str.trim().toLowerCase().replace(/\s+/g, '-')

    return (
        <div className={classes.wrapper}>
            {/* Filter Section */}
            <div className={classes.filter}>
                <div className={classes.filterTitle}>
                    <div className={classes.titleIcon}>
                        <MdManageSearch />
                    </div>
                    <p>Search filter</p>
                </div>

                <SearchBar search={props.search} setSearch={props.setSearch} />
                <div className={classes.listContainer}>
                    <div className={classes.inputField}>
                        <div className={classes.checkboxContainer}>
                            <div
                                className={`${props.isFeatured ? classes.active : classes.inactive} ${
                                    classes.checkboxWrapper
                                }`}>
                                <input
                                    type="checkbox"
                                    className={classes.checkbox}
                                    checked={props.isFeatured}
                                    onChange={() => {
                                        props.setIsFeatured(!props.isFeatured)
                                        props.setCheck(!props.check)
                                    }}
                                />
                                <div className={classes.featuredText}>
                                    Featured <FaStar className={classes.iconFeatured} />
                                </div>
                            </div>

                            <div
                                className={`${props.isVerified ? classes.active : classes.inactive} ${
                                    classes.checkboxWrapper
                                }`}>
                                <input
                                    type="checkbox"
                                    className={classes.checkbox}
                                    checked={props.isVerified}
                                    onChange={() => {
                                        props.setIsVerified(!props.isVerified)
                                        props.setCheck(!props.check)
                                    }}
                                />
                                <div className={classes.featuredText}>
                                    Verified <MdVerified className={classes.iconVerified} />
                                </div>
                            </div>
                        </div>

                        {/* <DatePicker
                                className={classes.datePicker}
                                selected={props.startDate}
                                onChange={handleStartDateChange}
                                showIcon
                                placeholderText="Start Date"
                                enableTabLoop={false}
                            />
                            <DatePicker
                                className={classes.datePicker}
                                selected={props.endDate}
                                onChange={handleEndDateChange}
                                showIcon
                                placeholderText="End Date"
                                enableTabLoop={false}
                            />
                            {(props.startDate?.length > 0 || props.endDate?.length > 0) && (
                                <button onClick={clearDate}>
                                    <ImCross />
                                </button>
                            )} */}

                        <DatePicker onDateChange={props.handleDateChange} />
                        <CSVLink
                            data={userInfoExportData}
                            filename={'biztrade-seller-info.csv'}
                            className={classes.exportCsv}>
                            <TbCloudDownload className={classes.csvIcon} />
                            All Seller Info
                        </CSVLink>
                    </div>
                    <div>
                        <PopUpOne
                            options={planOptions}
                            parentClass={'sortContainer'}
                            defaultValue={props.plan_type}
                            placeholder={'All Plans'}
                            onChange={(value) => props.setPlanType(value)}
                        />
                    </div>
                </div>
            </div>

            {/* Table Title */}
            <TitleContainer title={'Active Seller List'} isCount={true} count={props.pageAll} />

            {/* Seller Table */}
            <TableV1>
                <thead>
                    <tr className={classes.tableRow}>
                        <th>SL</th>
                        <th>Seller ID</th>
                        <th>Company Name</th>
                        <th>Logo</th>
                        <th>Owner</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>City</th>
                        <th>Category</th>
                        <th>Date</th>
                        <th>Commission</th>
                        <th>Subscription</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {props.sellers &&
                        props.sellers.map((data, index) => {
                            // ✅ Updated filter logic
                            const shouldShow =
                                (props.plan_type === '' || data.Seller.plan_type === props.plan_type) &&
                                (!props.isFeatured || data.Seller.is_feature) &&
                                (!props.isVerified || data.Seller.is_verify)

                            if (!shouldShow) return null

                            return (
                                <tr className={classes.row} key={index}>
                                    <td>{props.pageSkip + index + 1}</td>
                                    <td>{'S-' + data.Seller?.seller_full_id}</td>
                                    <td>
                                        <div id={classes.verified}>
                                            {data.Seller.is_verify && <MdVerified className={classes.iconVerified} />}
                                            <Link
                                                className={classes.shopName}
                                                to={`${homeUrl}/companies/${data?.Seller?.seller_full_id}/${removeSpace(
                                                    data?.Seller?.page_name
                                                )}`}>
                                                {data.Seller.page_name}
                                            </Link>
                                        </div>
                                    </td>
                                    <td>
                                        <img
                                            alt=""
                                            className={classes.logo}
                                            src={
                                                data.ImgLogo.image_url
                                                    ? data.ImgLogo.image_url
                                                    : `${cdnUrl}/logo/${data.ImgLogo.image_string}`
                                            }
                                        />
                                    </td>
                                    <td>{data.User.name}</td>
                                    <td className={classes.emailText}>
                                        {data?.User?.email ? (
                                            <>
                                                {data.User.email.split('@')[0]}
                                                <br />@{data.User.email.split('@')[1]}
                                            </>
                                        ) : (
                                            '-'
                                        )}
                                    </td>
                                    <td>{data.User.phone}</td>
                                    <td>{data.Seller.city}</td>
                                    <td>{data.Seller.category}</td>
                                    <td>{data.Seller.created_at.slice(0, 10)}</td>
                                    <td>{data.Commission?.final_percentage}%</td>
                                    <td>
                                        <div id={classes.subscription}>
                                            {data.Seller.is_feature && <FaStar className={classes.iconFeatured} />}
                                            {data.Seller.plan_type || '-'}
                                        </div>
                                    </td>
                                    <td>
                                        <div className={classes.action}>
                                            <Link className={classes.updateIcon}>
                                                <AiOutlineDollar
                                                    title="Commission"
                                                    size={18}
                                                    onClick={() => {
                                                        setCommissionPopup(true)
                                                        setSingleSellerInfo(data)
                                                    }}
                                                />
                                            </Link>
                                            <FontAwesomeIcon
                                                title="Information"
                                                className={classes.iconEdit}
                                                icon={faPenToSquare}
                                                onClick={() => setActivePopUp(index)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                            <Link className={classes.updateIcon2}>
                                                <MdOutlinePayment
                                                    title="Subscription"
                                                    size={18}
                                                    onClick={() => {
                                                        setSubsPopup(true)
                                                        setSingleSellerInfo(data)
                                                    }}
                                                />
                                            </Link>
                                        </div>
                                    </td>

                                    {activePopUp === index && (
                                        <td>
                                            <PopUp
                                                sellerName={data.User.name}
                                                userId={data.User.id}
                                                sellerId={data.Seller.id}
                                                active={data.User.is_active}
                                                featured={data.Seller.is_feature}
                                                verified={data.Seller.is_verify}
                                                basic={data.Seller.is_basic}
                                                standard={data.Seller.is_standard}
                                                premium={data.Seller.is_premium}
                                                check={props.check}
                                                setCheck={props.setCheck}
                                                btnClickPopUp={'1'}
                                                setActivePopUp={setActivePopUp}
                                                data={data}
                                                index={index}
                                            />
                                        </td>
                                    )}
                                </tr>
                            )
                        })}
                </tbody>
            </TableV1>

            {/* Popups */}
            {commissionPopup && (
                <Popup
                    setForm={setCommissionPopup}
                    form={commissionPopup}
                    singleSellerInfo={singleSellerInfo}
                    istrue={props.istrue}
                    setTrue={props.setTrue}
                />
            )}
            {subsPopup && <SubsPopup setForm={setSubsPopup} form={subsPopup} singleSellerInfo={singleSellerInfo} />}

            {/* Pagination */}
            <Pagination
                pageSkip={props.pageSkip}
                setPageSkip={props.setPageSkip}
                listItem={props.sellers}
                pageAll={props.pageAll}
            />
        </div>
    )
}
